import React from 'react';

/**
 * CustomerPagination - Pagination controls for customer table
 * @param {Object} props
 * @param {number} props.currentPage - Current page number
 * @param {number} props.totalPages - Total number of pages
 * @param {Function} props.onPageChange - Callback when page changes
 */
export function CustomerPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) {
        return null;
    }

    return (
        <div className="flex justify-center items-center mt-6 space-x-2 text-sm">
            <button
                onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded border text-gray-600 disabled:opacity-50"
            >
                Prev
            </button>
            {[...Array(totalPages)].map((_, i) => (
                <button
                    key={i}
                    onClick={() => onPageChange(i + 1)}
                    className={`px-3 py-1 rounded border ${
                        currentPage === i + 1 ? 'bg-primary text-white' : 'text-gray-700'
                    }`}
                >
                    {i + 1}
                </button>
            ))}
            <button
                onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded border text-gray-600 disabled:opacity-50"
            >
                Next
            </button>
        </div>
    );
}

